<template>
  <div class="pb-12">
    <el-dialog title="" :visible.sync="isShowDetailsAddons" width="35%">
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">
          Extensions Details
        </h3></template
      >

      <ExtentionDetailSummary />
    </el-dialog>

    <h2 class="text-565656 fsize16 font-semibold border-b pb-4 mt-10">
      Buy Extensions
    </h2>
    <div class="mt-6 pr-4">
      <div
        class="flex items-center mb-6 cursor-pointer"
        v-for="(item, index) in filteredExtension"
        :key="'item-' + index"
      >
        <div class="flex gap-6 items-center w-8/12">
          <!-- <img
            src="@/assets/images/airplane.png"
            class="object-contain wh-75px rounded-10px p-3 bg-cas"
            alt="banh"
          /> -->
          <img
            :src="showImage(item.image)"
            class="object-contain wh-75px rounded-10px p-3 bg-cas"
            alt="banh"
          />

          <div class="w-full">
            <h3 class="col-4f text-xl mb-0 font-semibold flex items-center">
              {{ item.name }}
              <div
                v-if="item.name === 'Metaverse'"
                v-tooltip.top="{
                  content:
                    'Platform to engage with virtual reality and augmented reality experience.',
                  class: 'toolcust',
                }"
              >
                <feather-icon
                  icon="InfoIcon"
                  class="ml-1 text-grey flex"
                  svgClasses="w-5 h-5"
                />
              </div>

              <div
                v-if="item.name === 'Booking Engine'"
                v-tooltip.top="{
                  content:
                    'Enabled appointment scheduling and management for your business.',
                  class: 'toolcust',
                }"
              >
                <feather-icon
                  icon="InfoIcon"
                  class="ml-1 text-grey flex"
                  svgClasses="w-5 h-5"
                />
              </div>

              <div
                v-if="item.name === 'Whatsapp Support'"
                v-tooltip.top="{
                  content:
                    'Platform to automate customer interactions and provide quick responses.',
                  class: 'toolcust',
                }"
              >
                <feather-icon
                  icon="InfoIcon"
                  class="ml-1 text-grey flex"
                  svgClasses="w-5 h-5"
                />
              </div>
            </h3>
            <!-- <p class="fsize12 font-medium mt-1">Price : {{ item.price }}</p> -->

            <!-- <p
              @click="showExtensionsDetails(item)"
              class="pt-2 fsize12 text-primary font-semibold text-underline cursor-pointer"
            >
              View Details
            </p> -->
          </div>
        </div>
        <div class="w-4/12 flex justify-end">
          <vs-button
            @click="totalExtenstions(item)"
            variant="primary"
            class="rounded-full bg-primary border-0 text-white font-semibold lg:py-4 md:py-3 py-2 px-8 sm-fsize12"
            v-if="!isSelected(item)"
            >Add
          </vs-button>
          <vs-button
            @click="totalExtenstions(item)"
            variant="primary"
            color="danger"
            class="rounded-full bg-danger border-0 text-white font-semibold lg:py-4 md:py-3 py-2 px-8 sm-fsize12"
            v-if="isSelected(item)"
            >Remove
          </vs-button>
        </div>
        <!-- <div class="w-2/12 flex justify-end cursor-pointer">
          <vs-button
            :type="[item.button === 'Add' ? 'filled' : 'border']"
            class="sm-button2 px-6 rounded-full"
            :class="[item.button === 'Add' ? 'bg-success' : 'bg-primary']"
            >{{ item.button }}</vs-button
          >
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import addOnsMaster from "@/Apicall/masters/addons.js";
import ExtentionDetailSummary from "./ExtentionDetailSummary";
import { mapState } from "vuex";
export default {
  data() {
    return {
      // extention: [
      //   {
      //     id: "01",
      //     image: require("@/assets/images/icons/ecommernce.svg"),
      //     title: "E-commerce",
      //     count: "INR 24,000 / Year",
      //     text: "View Details",
      //     button: "Add",
      //   },
      //   {
      //     id: "02",
      //     image: require("@/assets/images/icons/marketplace.svg"),
      //     title: "Marketplace",
      //     count: "INR 24,000 / Year",
      //     text: "View Details",
      //     button: "Added",
      //   },
      //   {
      //     id: "03",
      //     image: require("@/assets/images/icons/whatsapp.svg"),
      //     title: "WhatsApp Bot",
      //     count: "INR 24,000 / Year",
      //     text: "View Details",
      //     button: "Added",
      //   },
      //   {
      //     id: "03",
      //     image: require("@/assets/images/metavers.svg"),
      //     title: "Metaverse",
      //     count: "INR 24,000 / Year",
      //     text: "View Details",
      //     button: "Add",
      //   },
      //   {
      //     id: "03",
      //     image: require("@/assets/images/Booking Engine.svg"),
      //     title: "Booking Engine",
      //     count: "INR 24,000 / Year",
      //     text: "View Details",
      //     button: "Added",
      //   },
      //   {
      //     id: "03",
      //     image: require("@/assets/images/icons/social media.svg"),
      //     title: "Social",
      //     count: "INR 24,000 / Year",
      //     text: "View Details",
      //     button: "Add",
      //   },
      //   {
      //     id: "03",
      //     image: require("@/assets/images/icons/bloging.svg"),
      //     title: "Blogs",
      //     count: "INR 24,000 / Year",
      //     text: "View Details",
      //     button: "Added",
      //   },
      //   {
      //     id: "03",
      //     image: require("@/assets/images/elearning.svg"),
      //     title: "E-Learning",
      //     count: "INR 24,000 / Year",
      //     text: "View Details",
      //     button: "Added",
      //   },
      //   {
      //     id: "03",
      //     image: require("@/assets/images/portfolio.svg"),
      //     title: "Portfolio",
      //     count: "INR 24,000 / Year",
      //     text: "View Details",
      //     button: "Add",
      //   },
      //   {
      //     id: "03",
      //     image: require("@/assets/images/Ott.svg"),
      //     title: "OTT",
      //     count: "INR 24,000 / Year",
      //     text: "View Details",
      //     button: "Add",
      //   },
      // ],
      num: 1,
      isShowDetailsAddons: false,
      items: [],
      gettingextension: [],
      getSelectedExtension: [],
      filteredExtension: [],
      closeSwal: false,
      currencySymbol: "",
      gstNumber: 0,
    };
  },
  components: {
    ExtentionDetailSummary,
  },
  async mounted() {
    // this.getAddOns();

    await this.getExtensionsFunc();
    this.gettingextension = this.extensions;
    await this.defaultextension();
    // this.extensionRequest();
  },
  // watch: {
  //   extensions(value) {
  //     if (value) {
  //       this.gettingextension = value;
  //     }
  //   },
  // },
  methods: {
    async defaultextension() {
      await this.extensionRequest();
      let defaultValue = ["Blog", "Portfolio"];
      let defaultExt = await this.extensions.filter((item) =>
        defaultValue.includes(item.name)
      );
      let defaultExtReq = await this.getextensionsrequests.filter((item) =>
        defaultValue.includes(item.extensionId.name)
      );
      if (defaultExtReq.length == 0) {
        for (let index = 0; index < defaultExt.length; index++) {
          const req_data = await this.$store.dispatch(
            "Extensions/addExtensionRequest",
            {
              projectName: this.selectedProject.projectName,
              extensionId: defaultExt[index]._id,
              projectId: this.selectedProject._id,
              paymentStatus: "FREE",
              status: "Active",
            }
          );
        }
      }
    },
    async extensionRequest() {
      let payload = {
        projectName: this.selectedProject.projectName,
      };
      let data = await this.$store.dispatch(
        "Extensions/getExtensionRequest",
        payload
      );
      this.getSelectedExtension = data.data;
      console.log(this.extensions, "EXT");
      let filteredArray = this.extensions.filter(
        (obj1) =>
          !this.getSelectedExtension.some(
            (obj2) => obj1.name == obj2.extensionId.name
          )
      );
      console.log(filteredArray, "ARRAY");
      this.filteredExtension = filteredArray;
      this.currencySymbol = filteredArray[0].currency;
      this.gstNumber = parseInt(filteredArray[0].gstNumber);
      this.$emit("gstNumber", this.gstNumber);
      this.$emit("getCurrencySymbol", this.currencySymbol);
    },
    async getExtensionsFunc() {
      await this.$store.dispatch("Extensions/getExtensions");
    },
    showImage(value) {
      let default_image = require("@/assets/images/card1.png");
      return value
        ? `${process.env.VUE_APP_IMAGE_URL}/${value}`
        : default_image;
    },
    showExtensionsDetails(item) {
      this.$store.commit("Extensions/GET_SELECTED_EXTENSION", item);
      this.isShowDetailsAddons = true;
    },
    async totalExtenstions(n) {
      if (0 == this.selectedPlan[0].extension.remaining) {
        if (this.closeSwal == false) {
          this.$swal({
            text: `This Extension will be charged`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
          }).then((value) => {
            if (value.isConfirmed == true) {
              let data = this.totalextensions.findIndex((x) => x._id === n._id);
              if (data > -1) {
                this.items.splice(data, 1);
              } else {
                this.items.push(n);
              }
              this.$store.commit("Extensions/TOTAL_EXTENSIONS", this.items);
            }
          });
          this.closeSwal = true;
        } else {
          let data = this.totalextensions.findIndex((x) => x._id === n._id);
          if (data > -1) {
            this.items.splice(data, 1);
          } else {
            this.items.push(n);
          }
          this.$store.commit("Extensions/TOTAL_EXTENSIONS", this.items);
        }
      } else {
        this.$swal({
          text: `This is Free Extension and can't be changed`,
          icon: "info",
          showCancelButton: true,
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
        }).then(async (value) => {
          if (value.isConfirmed == true) {
            const req_data = await this.$store.dispatch(
              "Extensions/addExtensionRequest",
              {
                projectName: this.selectedProject.projectName,
                extensionId: n._id,
                projectId: this.selectedProject._id,
                paymentStatus: "FREE",
                status: "Active",
              }
            );
            let payload = {
              id: this.selectedPlan[0]._id,
              projectName: this.login.name,
            };
            let Extension = {
              remaining: this.selectedPlan[0].extension.remaining - 1,
              total: this.selectedPlan[0].extension.total,
            };
            Object.assign(payload, { extension: Extension });
            let data = await this.$store.dispatch(
              "billing/updatePlan",
              payload
            );
            this.$store.dispatch("billing/getPlan");
          }
          this.extensionRequest();
        });
      }
    },
    isSelected(value) {
      let data = this.totalextensions.findIndex((x) => x._id === value._id);
      if (data > -1) return true;
      else return false;
    },

    // async getAddOns() {
    //   const { data } = await addOnsMaster.getAddOns();
    //   this.addOns = data.data.map((x) => {
    //     return {
    //       ...x,
    //       booster: 0,
    //     };
    //   });
    // },
  },
  computed: {
    ...mapState("Extensions", [
      "extensions",
      "selectedextension",
      "totalextensions",
      "getextensionsrequests",
    ]),
    ...mapState("admin", ["login", "selectedPlan"]),
    ...mapState("user", ["selectedProject"]),
  },
};
</script>
